/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DataVaxiomInsuranceCarrierForm from 'DesignSystem/DataVaxiomInsuranceCarrierForm/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/Carrier/Content/Options/Create/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="small"
 height="auto"
 paddingLeft={0}
 paddingRight={0}
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<TysiaHeading
{...childProps}
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="New Insurance Carrier"
/>
)}
</TysiaModalHeader>
<DataVaxiomInsuranceCarrierForm
{...childProps}
  viewPath={`${viewPath}/DataVaxiomInsuranceCarrierForm`}
/>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}